import { makeStyles } from '@material-ui/core/styles';
import cards from '../../assets/cards.png'
export default makeStyles((theme) => ({
   layer : {
       backgroundImage :`url(${cards})`,
       height: "100%",
       backgroundPosition: "right",
       backgroundRepeat: "no-repeat",
       padding: "10vw 7vw",
       backgroundSize: "contain"
   }
}));